import React from "react";
import s from "./TextMAS.module.scss";
import c from "lib/style/colorVar.scss";

/**
 * TextMAS input component
 *
 * @param {Object} props
 * @param {"light"|"regular"|"medium"|"semibold"|"bold"} props.fontWeight
 * @param {"small"|"regular"|"medium"|"large"} props.fontSize
 * @returns
 */

const TextMAS = ({
  fontWeight,
  fontSize,
  className,
  color,
  text,
  lineBreak,
  nowrap,
  breakWord,
  style,
  children,
}) => {
  const fontWeightClass = [
    "light",
    "regular",
    "medium",
    "semibold",
    "bold",
  ].includes(fontWeight && String(fontWeight).toLowerCase())
    ? `TextMAS-fontWeight-${fontWeight.toLowerCase()}`
    : !fontWeight
    ? "TextMAS-fontWeight-regular"
    : undefined;

  const fontSizeClass = ["small", "regular", "medium", "large"].includes(
    fontSize && String(fontSize).toLowerCase(),
  )
    ? `TextMAS-fontSize-${fontSize.toLowerCase()}`
    : !fontSize
    ? "TextMAS-fontSize-regular"
    : undefined;

  const classNames = [
    className,
    s["TextMAS-base"],
    s[fontWeightClass],
    s[fontSizeClass],
  ]
    .filter((e) => e)
    .join(" ");

  const styles = {
    ...(!fontWeightClass && fontWeight && { fontWeight: fontWeight }),
    ...(!fontSizeClass && fontSize && { fontSize: fontSize }),
    color: c[color] ?? color,
    ...(nowrap && { whiteSpace: "nowrap" }),
    ...(breakWord && { wordBreak: "break-word" }),
    ...style,
  };

  return (
    <>
      <span className={classNames} style={styles}>
        {text}
        {children}
      </span>
      {lineBreak && <br />}
    </>
  );
};

export default React.memo(TextMAS);
